import Lottie from "lottie-react";
import loadingAnimation from "assets/lottie/loader-cabal_town.json";
import { Typography } from "@mui/material";
import { Col, Row } from "v2/components/base/Flex/ui";
import { useCheckViewPoint, VIEW_POINT_CONFIG } from "hooks/useCheckViewPoint";
import { HEADER_HEIGHT } from "consts";

const ScrollableLoading = () => {
  const isMobile = useCheckViewPoint(VIEW_POINT_CONFIG.MOBILE);

  return (
    <Col type="cc" padding={isMobile ? `0px 0px 280px` : "20px"} fullWidth fullHeight>
      <Row
        type="cc"
        sx={{
          width: "136px",
          height: "99px",
        }}>
        <Lottie animationData={loadingAnimation} />
      </Row>
      <Col
        type="sc"
        sx={{
          textAlign: "center",
          color: "#fff",
          gap: "10px",
          marginTop: "-8px",
        }}>
        <Typography variant="mobile-display-xs">Loading...</Typography>
      </Col>
    </Col>
  );
};

export default ScrollableLoading;
